import { section } from "@/neon";

import carousel from "@/components/carousel";
import scrollIntoView from "@/lib/scrollIntoView";
import orderCarouselItems from "@/lib/orderCarouselItems";

const selectors = {
  carouselContainer: ".testimonials__slides",
  animatedSlides: ".animates",
};

section("testimonials", {
  onLoad() {
    this.animatedSlides = this.container.querySelectorAll(
      selectors.animatedSlides
    );
    this.carouselContainer = this.container.querySelector(
      selectors.carouselContainer
    );

    this.carousel = carousel(this.container);

    if (this.animatedSlides.length) {
      this._initScrollAnimation(
        orderCarouselItems(this.container, this.animatedSlides)
      );
    }
  },

  _initScrollAnimation(slides) {
    const { textPosition } = this.container.dataset;

    // If the caorusle is inline the animation needs to delay
    // to account for text-block fade in.
    const animationDelay = textPosition === "top" ? 0 : 750;

    this.scrollAnimation = scrollIntoView(
      this.container,
      slides,
      animationDelay
    );
  },

  onBlockSelect({ target: slide }) {
    this.carousel.goToSlide(slide.dataset.index);
  },

  onUnload() {
    this.carousel.unload();

    if (this.animatedSlides.length) {
      this.scrollAnimation.unload();
    }
  },
});
